import React from 'react';
import { VStack, HStack, Text, Box, View, Skeleton } from 'native-base';

// Assets
import { theme } from '@breakroom-nx/assets';

// Classes & Types
import { UserAvatar, ChatBubble } from '../../';
import { Notification } from '@breakroom-nx/classes';
import { NotificationType, timeFrom } from '@breakroom-nx/helpers';
import { useGetNotificationDataQuery } from '@breakroom-nx/redux';

export interface NotificationInfoCellProps {
  notification: Notification;
}

export function NotificationInfoCell({
  notification,
}: NotificationInfoCellProps) {
  const { data, isLoading } = useGetNotificationDataQuery(notification);

  return (
    <HStack
      alignItems={'end'}
      space={5}
      rounded={'lg'}
      p={5}
      mb={5}
      bg={theme.colors.surface[200]}
    >
      {isLoading ? (
        <VStack space={2} flex={2} alignItems={'flex-start'}>
          <Skeleton
            h={16}
            w={16}
            rounded="full"
            startColor={theme.colors.surface[400]}
          />
          <Skeleton h={5} rounded="lg" startColor={theme.colors.surface[400]} />
        </VStack>
      ) : (
        <>
          <VStack space={2} flex={2} alignItems={'flex-start'}>
            <HStack space={3} alignItems={'center'}>
              {data?.room ? (
                <Box>
                  <ChatBubble
                    room={data.room}
                    key={data.room.id}
                    disabled={true}
                  />
                  {data.user && (
                    <View position={'absolute'} right={0} bottom={0}>
                      <UserAvatar uid={data.user.uid} borderColor={'white'} />
                    </View>
                  )}
                </Box>
              ) : (
                data?.user && (
                  <UserAvatar uid={data.user.uid} size={25} noBorder />
                )
              )}

              <Text color={'white'} fontWeight={'bold'}>
                {notification.type}
              </Text>
            </HStack>
            {notification.type !== NotificationType.System ? (
              data?.room ? (
                <Text>
                  <Text
                    color={theme.colors.white}
                    fontSize={16}
                    fontWeight={600}
                  >
                    {data!.user?.username}
                  </Text>
                  <Text
                    color={theme.colors.surface[600]}
                    fontSize={16}
                    fontWeight={600}
                  >
                    {` ${notification.text.toLowerCase()}`}
                  </Text>
                  <Text
                    color={theme.colors.white}
                    fontSize={16}
                    fontWeight={600}
                  >
                    {data.room.title}
                  </Text>
                </Text>
              ) : (
                data?.user && (
                  <Text>
                    <Text
                      color={theme.colors.yellow[200]}
                      fontSize={16}
                      fontWeight={600}
                    >
                      {data!.user?.username}
                    </Text>
                    <Text
                      color={theme.colors.surface[600]}
                      fontSize={16}
                      fontWeight={600}
                    >
                      {` ${notification.text.toLowerCase()}`}
                    </Text>
                  </Text>
                )
              )
            ) : (
              <Text
                color={theme.colors.surface[600]}
                fontSize={16}
                fontWeight={600}
              >
                {notification.text}
              </Text>
            )}

            <Text
              color={theme.colors.surface[500]}
              fontSize={14}
              fontWeight={400}
            >
              {timeFrom(new Date(notification.timestamp), true)}
            </Text>
          </VStack>
        </>
      )}
    </HStack>
  );
}

export default React.memo(NotificationInfoCell);
